<template>
  <div class="px-3 pb-5">
    <b-row class="pt-5 pb-5 text-center"><h4><b>Please connect to Facebook in order to share this post.</b></h4></b-row>
    <b-row class="py-3 justify-content-center">
      <b-button @click="loginWithFacebook">Login with Facebook</b-button>
    </b-row>
  </div>
</template>

<script>
import CurrentUserEditMutation from '@/graphql/mutations/CurrentUserEdit.gql';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    entryId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapRoot([ 'user' ]),
  },
  methods: {
    loginWithFacebook() {
      const permissions = 'public_profile, user_posts';
      // eslint-disable-next-line no-undef
      FB.login(
        async response => {
          if (response.authResponse) {

            const { id: userID } = this.user;
            const update = {
              state: {
                facebook: {
                  accessToken: response.authResponse.accessToken,
                  loginAccessExpiresIn: response.authResponse.expiresIn,
                  accessDataExpiresAt: response.authResponse.data_access_expiration_time,
                  scope: permissions,
                  id: response.authResponse.userID,
                  loginStatus: response.status,
                  updatedTime: Date.now()
                },
              },
            };
            this.$log.debug('update', { update });
            await this.$apollo.mutate({
              mutation: CurrentUserEditMutation,
              variables: { userID, update },
            });

            this.$bvModal.hide(`connect-facebook-${this.entryId}`);
          } else {
            console.log('User cancelled login or did not fully authorize.');
          }
        },
        { scope: permissions }
      );
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/content-share/ConnectFacebook.vue